import { Component } from '@angular/core';
import { DialogModule } from "primeng/dialog";

@Component({
    selector: 'app-keine-anmeldung',
    standalone: true,
    imports: [
        DialogModule,
    ],
    templateUrl: './keine-anmeldung.component.html',
    styleUrl: './keine-anmeldung.component.scss',
})
export class KeineAnmeldungComponent {
    visible: boolean;

    openOverlay() {
        this.visible = true;
    }

    closeOverlay() {
        this.visible = false;
    }
}
